import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dateFilter from '@/filters/date.filter'
import vuetify from '@/plugins/vuetify'
import toastr from 'toastr/toastr'
import draggable from 'vuedraggable'
import axios from '@/plugins/axios'
import i18n from './i18n'

Vue.component('vue-custom-scrollbar', require('@/components/vueCustomScrollbar.vue').default)
Vue.component('draggable', draggable);

Vue.prototype.$axios = axios;
Vue.prototype.$toastr = toastr;

store.subscribe(() => {
  localStorage.setItem('state', JSON.stringify(store.state));
});

Vue.config.productionTip = false

Vue.filter('date', dateFilter)

new Vue({
  render: h => h(App),  
  vuetify,
  router,
  store,
  i18n,
  beforeCreate() {
    this.$store.commit('initializeState');
  },
}).$mount('#app')
